import React from "react";
import { CustodianContainer } from "../../../containers";

const Custodian = (props) => {
  return <CustodianContainer {...props} />;
};

export default Custodian;
